export default __webpack_public_path__ + "6a9ad0a1ab699d61437879bb41c5a654.jpg";